import { appConfig } from '@/config/app';
import type { SourceId } from '@/types/market';

export interface SnapshotManifestEntry {
  file: string;
  label: string;
  periodLabel: string;
  publishedAt: string;
  isSample: boolean;
}

export type SnapshotManifest = Partial<Record<SourceId, SnapshotManifestEntry>>;

let cached: SnapshotManifest | null = null;

/**
 * Loads public/data-snapshots/manifest.json, which tells each adapter which
 * file to fetch and what period/publish-date to stamp on the resulting
 * rows. Falls back to an empty manifest (adapters then fall back further to
 * their own bundled defaults) if the manifest itself is missing -- this is
 * intentionally forgiving since the whole point of static-snapshot mode is
 * that a non-engineer may replace these files without touching code.
 */
export async function loadSnapshotManifest(signal?: AbortSignal): Promise<SnapshotManifest> {
  if (cached) return cached;
  try {
    const res = await fetch(`${appConfig.dataSnapshotBasePath}/manifest.json`, { signal });
    if (!res.ok) throw new Error(`manifest fetch failed: ${res.status}`);
    const json = (await res.json()) as { sources?: SnapshotManifest };
    cached = json.sources ?? {};
  } catch (err) {
    console.warn('[snapshotManifest] falling back to empty manifest:', err);
    cached = {};
  }
  return cached;
}
